import { Alert, Loader, Text } from '@mantine/core';
import type { UseQueryResult } from '@tanstack/react-query';
import { KAYIT_ERISIM_YOK_METNI } from '@isg/validation';
import { ApiError } from '../api/client';
import { ANLAM } from '../theme';

/**
 * Liste ekranlarının ortak durum parçaları (F1·S10). 403 ekranda saklanmaz:
 * API'nin bahçe/şapka reddi açık mesajla gösterilir (ekran API'ye güvenir,
 * ikinci filtre yazmaz). Boş bahçe = boş liste + açıklayıcı mesaj (B3).
 */

/**
 * ✏️ **BULGU 103 (K-103e) — `kayit` KİPİ:** bildirim/iş satırının hedefi olan
 * kayıt sayfası. Kapı 403 dönünce sunucunun iç sebebi yerine tek sebep satırı
 * çıkar (`KAYIT_ERISIM_YOK_METNI`) — kaydı adlandırmaz, bahçe dışına bilgi
 * sızdırmaz. Bağ yetkiyi genişletmez; karar yine sunucudadır.
 */
export function QueryStatus({
  queries,
  kayit = false,
}: {
  queries: UseQueryResult<unknown>[];
  kayit?: boolean;
}): React.JSX.Element | null {
  if (queries.some((q) => q.isPending)) return <Loader size="sm" />;
  const failed = queries.find((q) => q.isError);
  if (failed) {
    const error = failed.error;
    const yetkiRet = error instanceof ApiError && error.status === 403;
    const mesaj =
      kayit && yetkiRet
        ? KAYIT_ERISIM_YOK_METNI
        : error instanceof Error
          ? error.message
          : 'Bilinmeyen hata';
    return (
      <Alert
        color={yetkiRet ? ANLAM.dikkat : ANLAM.engel}
        role="alert"
        data-testid={kayit && yetkiRet ? 'kayit-erisim-yok' : undefined}
      >
        {mesaj}
      </Alert>
    );
  }
  return null;
}

export function BosListeNotu({ mesaj }: { mesaj: string }): React.JSX.Element {
  return (
    <Text size="sm" c="dimmed" data-testid="bos-liste">
      {mesaj}
    </Text>
  );
}
